import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import ProjetComponent from '../../../components/Mouvement/Panel/ProjetComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class ProjetPanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.PROJET;
    this.icon = { name: 'briefcase' };
  }

  getLibelle = () => 'Projet';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.identifiantProjet);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <ProjetComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default ProjetPanel;
